(window as any).git_hash = "875a9457e0146cbf758d3f3628f2d30cf55caecc"